// What to log for a failed request: the message and HTTP status only. The raw
// Axios error carries config.headers, which can include the bearer token.
export const describeError = (
	e: unknown,
): { message?: string; status?: number } => {
	const err = e as { message?: unknown; response?: { status?: unknown } };
	return {
		message: typeof err?.message === 'string' ? err.message : undefined,
		status:
			typeof err?.response?.status === 'number'
				? err.response.status
				: undefined,
	};
};
